import { PrismicRichText } from '@prismicio/react';
import { Button } from 'remote-com-shared/components/Button';
import ContentContainerRaw from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper as SectionWrapperRaw } from 'remote-com-shared/components/SectionWrapper';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import styled from 'styled-components';

import { DescriptionComponent, TitleComponent } from '../sharedStyles';

const Title = styled(TitleComponent)`
  ${({ theme }) => theme.typography.scale3};
  color: var(--colors-blank);
  margin-bottom: 40px;
  max-width: 640px;

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
`;

const SectionWrapper = styled(SectionWrapperRaw)`
  background-color: var(--color-tone-font);
  background-image: url('/background-illustration/CtaPattern2.svg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
`;

const ContentContainer = styled(ContentContainerRaw)`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
`;

const CTAButton = styled(Button)`
  && {
    background: var(--colors-blank);
    color: var(--colors-darkBlue);
  }
`;

export function CustomPrimaryCTASlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { sectionId, title, description, buttonLabel, buttonLink } = primary;

  return (
    <SectionWrapper $size="small" id={sectionId}>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(description) && (
          <DescriptionComponent $textColor="var(--colors-blank)">
            <PrismicRichText field={description} />
          </DescriptionComponent>
        )}
        {buttonLink && buttonLabel && (
          <CTAButton href={buttonLink.url} target={buttonLink.target}>
            {buttonLabel}
          </CTAButton>
        )}
      </ContentContainer>
    </SectionWrapper>
  );
}
